<template>
  <v-app>
    <div v-if="testLoaded">
      <v-app-bar app color="primary" dark>
        <!-- TODO: ovo da se sredi -->
        <div v-if="testData.company_logo_show">
          <v-img
            class="mx-2"
            max-height="40"
            max-width="40"
            contain
            :src="testData.company_logo_img"
          ></v-img>
        </div>
        <v-toolbar-title>{{ testData.company_name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="testData.start_test === true">
          <span>{{ testData.assignee }}</span>
          <v-chip class="ma-2" color="indigo" text-color="white">
            <v-avatar left>
              <v-icon>mdi-clock</v-icon>
            </v-avatar>
            {{ testData.test_duration }}
          </v-chip>
        </div>
      </v-app-bar>

      <v-content>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-row align="center" justify="center" class="ovde-boja">
                <v-col cols="12" xl="6" lg="6" md="8" sm="12" xs="12">
                  <!-- <pre>{{ testData }}</pre> -->
                  <router-view></router-view>
                  <!-- <Test /> -->
                  <!-- <pre>{{ testData.questionList }}</pre> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
      <Footer></Footer>
    </div>
    <div v-else>
      <h1>Loading, please wait...</h1>
    </div>
  </v-app>
</template>

<script>
import Footer from './views/shared/Footer.vue';
// import themeSetup from './utility/themeSetup.js';

export default {
  name: 'App',

  computed: {
    testData() {
      return this.$store.state.initialTestData.tequsDocument.info;
    },
    testLoaded() {
      return this.$store.state.initialTestData.contentLoaded;
    },
  },
  methods: {
    // customTheme(theme_data) {
    //   if (theme_data.theme_setup.darkTheme) {
    //     this.$vuetify.theme.dark = true;
    //     this.$vuetify.theme.themes.dark = theme_data.theme_setup.color;
    //   } else {
    //     this.$vuetify.theme.themes.light = theme_data.theme_setup.color;
    //   }
    // },
  },
  data() {
    return {
      pageLoaded: false,
    };
  },
  components: {
    Footer,
  },
  created() {
    const id = this.$route.query.tqid;
    const lang = this.$route.query.langId;
    this.$store.dispatch('initialTestData/fetchTequsDocument', { tqId: id, langId: lang });
    // this.customTheme(this.testData.info.theme);
    // this.pageLoaded = true;
  },
};
</script>

<style lang="css">
.v-stepper__header {
  overflow: auto;
  display: flex;
  flex-wrap: nowrap !important;
  justify-content: left;
}
</style>
